module.exports = __webpack_public_path__ + "fonts/quicksand-bold.0738679d.ttf";